import { supabase } from '../lib/supabase';

const client = () => {
  if (!supabase) throw new Error('Supabase client is not configured.');
  return supabase;
};

async function getConfiguration(key: string, organizationId?: string) {
  let query = client().from('configurations').select('*').eq('key', key);
  if (organizationId && organizationId !== 'ALL') query = query.eq('organization_id', organizationId);
  const { data, error } = await query.maybeSingle();
  if (error) throw error;
  return data;
}

export const configurationsApi = {
  getConfiguration,
  async saveConfiguration(key: string, value: any, organizationId?: string) {
    const record = { key, value, organization_id: organizationId || null, updated_at: new Date().toISOString() };
    const { data, error } = await client().from('configurations').upsert(record, { onConflict: 'organization_id,key' }).select().single();
    if (error) throw error;
    return data;
  },
  async getTicketNumberConfig(organizationId?: string) {
    return getConfiguration('ticket_numbering', organizationId);
  },
  async saveTicketNumberConfig(config: any, organizationId?: string) {
    return this.saveConfiguration('ticket_numbering', config, organizationId);
  },
  async resetTicketNumberConfig(_targetNumber: number, _organizationId?: string): Promise<{ success: boolean; message?: string; error?: string }> {
    throw new Error('Resetting ticket sequences requires a privileged Supabase Edge Function.');
  }
};
